import { Image, H1, Ol, P, Updated } from "design_lib";

export default function EntryModes() {
  return (
    <div>
      <H1>Difinition/Description</H1>
      <P>
        When businesses are considering international expansion, it is not always clear which avenue
        aligns with corporate objectives. Understanding the various entry modes (as well as their
        pros and cons) can assist business leaders as they identify which strategy is optimal for
        their situation.
      </P>
      <Ol>
        <li>
          <b>Exporting</b> - The process of producing a good or service in one country and selling
          it to another.
        </li>
        <Ol type="a">
          <li>
            Ex. Apple selling iPhones directly to consumers in China through its online store and
            authorized retailers.
          </li>
        </Ol>
        <li>
          <b>Turnkey Operations</b> - A company builds a foreign facility while a client owns and
          operates it.
        </li>
        <Ol type="a">
          <li>
            Ex. A construction company builds a power plant in Africa, trains local personnel, and
            then hands over ownership and operations to a local government agency.
          </li>
        </Ol>
        <li>
          <b>Licensing</b> - A contractual agreement granting the licensee certain rights such as
          producing or selling the product, displaying brand names, or using licensor’s IP.
        </li>
        <Ol type="a">
          <li>
            Ex. Coca-Cola grants a bottling company in India the right to produce and sell Coke
            products using the Coca-Cola brand and recipe.
          </li>
        </Ol>
        <li>
          <b>Franchising</b> - Similar to licensing, but the franchiser maintains an active role in
          the ongoing operations.
        </li>
        <Ol type="a">
          <li>
            Ex. McDonald's grants franchise rights to an entrepreneur in France, who opens and
            operates a McDonald's restaurant following company standards and procedures.
          </li>
        </Ol>
        <li>
          <b>Joint Ventures</b> - A new legal entity created and owned by multiple companies in
          different countries.
        </li>
        <Ol type="a">
          <li>
            Ex. BMW partners with a Chinese automaker to establish a new car manufacturing plant in
            China, sharing ownership, profits, and management responsibilities.
          </li>
        </Ol>
        <li>
          <b>Wholly Owned Subsidiary</b> - A parent company sets ups a new legal entity that is
          legally separate but that it fully owns.
        </li>
        <Ol type="a">
          <li>
            Ex. Amazon establishes a fully owned subsidiary in Germany to build its own fulfillment
            centers and deliver products directly to customers.
          </li>
        </Ol>
      </Ol>
      <P>
        By understanding these entry modes you can correctly determine the amount of control and
        risk you would like to undertake.
      </P>
      <Image
        src={require("lib/img/concepts/EntryModes.png")}
        alt="chart comparing and contrasting different entry modes"
      />
      <Updated date="2/21/25" />
    </div>
  );
}
